var axios;
var Swiper;
var WebSite;
(function (WebSite) {
    var AFWSwiper = (function () {
        function AFWSwiper(element, swiperSettings) {
            if (swiperSettings === void 0) { swiperSettings = null; }
            this.SwiperSettings = null;
            var swpSetJson = swiperSettings || element.getAttribute('data-swiper-settings');
            if (swpSetJson) {
                this.SwiperSettings = JSON.parse(swpSetJson);
            }
            new Swiper(element, this.SwiperSettings);
        }
        return AFWSwiper;
    }());
    WebSite.AFWSwiper = AFWSwiper;
    var Main = (function () {
        function Main() {
            this.pills = function () {
                $("a.nav-link").click(function (et) {
                    $("a.nav-link").removeClass("active");
                    var target = et.target;
                    $(target).addClass("active");
                    $(".tab-pane").removeClass("show active");
                    $("#" + target.id + "-pane").addClass("show active");
                });
            };
            this.homepageMainSwiper = function () {
                var elements = document.querySelectorAll('[data-swiper-homepageMainSwiper-init]')[0];
                var el = elements;
                var swiper = new Swiper(el, {
                    slidesPerView: 1,
                    spaceBetween: 30,
                    loop: true,
                    breakpoints: {
                        992: {
                            slidesPerView: 4,
                        },
                        768: {
                            slidesPerView: 3,
                        },
                        480: {
                            slidesPerView: 2,
                        }
                    },
                    navigation: {
                        nextEl: '.swiper-homepageMainSwiper-button-next',
                        prevEl: '.swiper-homepageMainSwiper-button-prev'
                    },
                });
            };
            this.gallerySwiper = function () {
                var elements = document.querySelectorAll('[data-swiper-gallerySwiper-init]')[0];
                var el = elements;
                var swiper = new Swiper(el, {
                    slidesPerView: 1,
                    spaceBetween: 30,
                    centeredSlides: true,
                    loop: true,
                    loopAdditionalSlides: 2,
                    pagination: {
                        el: '.swiper-gallery-pagination',
                        type: 'custom',
                        renderCustom: function (swiper, current, total) {
                            var text = "";
                            for (var i = 1; i <= total; i++) {
                                if (i == 1) {
                                    text += "<span class='numbers'>0" + current + "</span>";
                                }
                                var active = (current == i) ? "active" : "";
                                text += "<span class='custom-pag " + active + "' ></span>";
                                if (i == total) {
                                    text += "<span class='numbers'>0" + total + "</span>";
                                }
                            }
                            return text;
                        }
                    },
                    on: {
                        slideChange: function () {
                            var childNum = $(".swiper-gallery-pagination").children().length - 2;
                            var pagWidth = 360 / childNum;
                            $(".custom-pag").css("width", pagWidth + "px");
                        }
                    },
                    breakpoints: {
                        992: {
                            slidesPerView: 1,
                        },
                        768: {
                            slidesPerView: 1,
                        }
                    },
                    navigation: {
                        nextEl: '.swiper-gallerySwiper-button-next',
                        prevEl: '.swiper-gallerySwiper-button-prev'
                    },
                });
            };
            this.hangWebsiteSubmitForms = function () {
                var elements = document.querySelectorAll('[data-wssubmitform]');
                for (var i = 0; i < elements.length; i++) {
                    var el = elements[i];
                    hangAsyncSubmitToForm(el);
                }
            };
            this.bindSwiperTmpFunc = function () {
                var elements = document.querySelectorAll('[data-swiper-init]');
                for (var i = 0; i < elements.length; i++) {
                    var el = elements[i];
                    new WebSite.AFWSwiper(el);
                }
            };
            this.referencesSwiper = function () {
                var elements = document.querySelectorAll('[data-swiper-references-init]')[0];
                var el = elements;
                var swiper = new Swiper(el, {
                    slidesPerView: 1,
                    spaceBetween: 30,
                    centeredSlides: true,
                    loop: true,
                    slideToClickedSlide: true,
                    breakpoints: {
                        992: {
                            slidesPerView: 3,
                        },
                        768: {
                            slidesPerView: 2,
                        }
                    },
                    navigation: {
                        nextEl: '.swiper-references-button-next',
                        prevEl: '.swiper-references-button-prev'
                    },
                });
                swiper.on("slideChange", function () {
                    $(".comments-block").removeClass("active");
                    $(".comments").find('[data-index="' + swiper.realIndex + '"]').addClass("active");
                });
            };
            this.stickyNavigation = function () {
                var header = $("header");
                if ($(window).scrollTop() >= 1) {
                    header.addClass("sticky");
                }
                else {
                    header.removeClass("sticky");
                }
                $(window).scroll(function () {
                    if ($(window).scrollTop() >= 1) {
                        header.addClass("sticky");
                    }
                    else {
                        header.removeClass("sticky");
                    }
                });
            };
            this.mobileMenu = function () {
                var hamburger = $("#hamburger-menu");
                var mobileMenu = $("#mobile-menu");
                var header = $("header");
                var body = $("body");
                var buttonsMobileMenu = $(".mobile-menu-footer .btn");
                hamburger.on("click", function () {
                    mobileMenu.toggleClass("open");
                    hamburger.toggleClass("open");
                    body.toggleClass("overflow");
                    if (!header.hasClass("sticky")) {
                        header.addClass("sticky");
                    }
                });
                buttonsMobileMenu.on("click", function () {
                    mobileMenu.toggleClass("open");
                    hamburger.toggleClass("open");
                    body.toggleClass("overflow");
                });
            };
            this.homepageMainSwiper();
            this.gallerySwiper();
            this.hangWebsiteSubmitForms();
            this.bindSwiperTmpFunc();
            this.referencesSwiper();
            this.stickyNavigation();
            this.mobileMenu();
            this.pills();
        }
        return Main;
    }());
    WebSite.Main = Main;
    function hangAsyncSubmitToForm(form) {
        form.addEventListener('submit', function (e) {
            var formEl = $(this);
            if (!formEl.valid())
                return;
            e.preventDefault();
            $.ajax({
                type: "POST",
                dataType: "JSON",
                method: "POST",
                data: AllForWeb.getFormData(formEl)
            }).then(function (result) {
                var formResponse = formEl.find(".form-respons");
                formResponse.show();
                var formStructure = formEl.find(".form-submit");
                formStructure.hide();
                setTimeout(function () {
                    formEl.find('input').not('[type=hidden], [type=checkbox]').val('');
                    var formResponse = formEl.find(".form-respons");
                    formResponse.hide();
                    var formStructure = formEl.find(".form-submit");
                    formStructure.show();
                }, 3000);
            }, function (err) {
            });
        });
    }
    WebSite.hangAsyncSubmitToForm = hangAsyncSubmitToForm;
})(WebSite || (WebSite = {}));
(function () {
    new WebSite.Main();
    var domainName = window.location.hostname;
    var cookieMain = $('.cookie');
    var cookieWarning = $(".cookie-dialog", cookieMain);
    $("#accept-cookies", cookieMain).on('click', function () {
        Cookies.set("analytic_consent", "1", { expires: 365, path: '/', domain: domainName });
        Cookies.set("analytic_consentNoPopUp", "1", { expires: 30, path: "/", domain: domainName });
        $('.cookie-dialog', cookieMain).fadeOut();
        window.location.reload();
    });
    var lastScrollTop = 0;
    $(window).on('scroll', function () {
        var el = $('.landing-shape');
        var currentBottomOffset = parseInt(el.css('bottom'));
        var st = $(this).scrollTop();
        if (st > lastScrollTop) {
            el.css('bottom', currentBottomOffset + 5 + "px");
        }
        else {
            el.css('bottom', currentBottomOffset - 5 + "px");
        }
        lastScrollTop = st;
    });
    $('.mobile-dropdown-toggle').on('click', function () {
        $('.mobile-dropdown').toggleClass('show');
    });
    var childNum = $(".swiper-gallery-pagination").children().length - 2;
    var pagWidth = 360 / childNum;
    $(".custom-pag").css("width", pagWidth + "px");
})();
$(document).ready(function () {
    $('.third-button').on('click', function () {
        $('.animated-icon3').toggleClass('open');
        $('.mobile-navigation').toggleClass('hidden');
    });
});
function closeNavigation() {
    $('.animated-icon3').toggleClass('open');
    var x = $(window).width();
    $('.navbar-collapse').toggleClass('show');
    $('.mobile-navigation').toggleClass('hidden');
}
//# sourceMappingURL=Main.js.map